exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/~/core-js/modules/_object-pie.js
// module id = ../../../../core-js/modules/_object-pie.js
// module chunks = 0